<template>
  <v-text-field
    ref="amount"
    v-model="amount"
    :label="label"
    :error-messages="errorMessages"
    :rules="rules"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    style="direction: ltr; text-align: left"
  />
</template>

<script>
  import { mask, unmask } from '@/util/helpers'
  export default {
    name: 'InputMoney',
    props: {
      options: {
        type: Object,
        default: () => { return {} },
      },
      label: { type: String },
      errorMessages: { type: String },
      rules: { type: Array },
      value: [String, Number],
      required: { type: Boolean, default: true },
      readonly: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
    data: () => {
      return {
        amount_: 0,
      }
    },
    computed: {
      amount: {
        get () {
          return mask(this.amount_, 0)
        },
        set (value) {
          this.amount_ = unmask(value)
          this.$emit('input', this.amount_)
        },
      },
    },
    watch: {
      value: {
        handler (val, oldVal) {
          this.amount = val
        },
      },
    },
  }
</script>
